const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background-primary">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
      <p className="text-text-secondary text-sm">Loading...</p>
    </div>
  </div>
);

export default PageLoader;
